import { render, staticRenderFns } from "./Weekplans.vue?vue&type=template&id=75f0fc7a&scoped=true&"
import script from "./Weekplans.vue?vue&type=script&lang=ts&"
export * from "./Weekplans.vue?vue&type=script&lang=ts&"
import style0 from "./Weekplans.vue?vue&type=style&index=0&id=75f0fc7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f0fc7a",
  null
  
)

export default component.exports